import ProfileArchivePage from './ProfileArchivePage'

export default ProfileArchivePage
